import { _A, _E, _R, _S1, _S2, _U, _W } from "./commons.mjs";
export const EffectURI = "Effect";
export class Base {}
/**
 * @ets_optimize identity
 */

export function instruction(self) {
  // @ts-expect-error
  return self;
}
//# sourceMappingURL=effect.mjs.map